module.exports = __webpack_public_path__ + "static/press-social-media-2fd4b9400f102505da66ddf063f5aa33.png";